@if (size() === LoadingSize.SMALL) {
  <div class="flex flex-col items-center justify-center p-2 rounded-sm shadow-sm">
    <p-progressSpinner [style]="{width: '30px', height: '30px'}" />
    <p class="text-xs mt-2">Loading...</p>
  </div>
}

@if (size() === LoadingSize.MIDDLE) {
  <div class="flex flex-col items-center justify-center p-4 rounded-sm shadow-sm">
    <p-progressSpinner [style]="{width: '60px', height: '60px'}" />
    <p class="text-sm mt-2">Loading...</p>
  </div>
}

@if (size() === LoadingSize.LARGE) {
  <div class="flex flex-col items-center justify-center p-6 rounded-sm shadow-sm">
    <p-progressSpinner />
    <p class="mt-4">Loading...</p>
  </div>
}
